/* Badminton People theme JS — reveals, parallax, quick view, finder, sort.
   Idempotent: safe to load once per page from multiple sections (defer + guard). */
(function () {
  if (window.__bpThemeInit) return;
  window.__bpThemeInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveals ---------- */
  function initReveals() {
    var els = document.querySelectorAll('[data-bp-reveal]:not(.bp-in)');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('bp-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('bp-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- parallax ---------- */
  function initParallax() {
    if (reduced) return;
    var ticking = false;
    function update() {
      ticking = false;
      document.querySelectorAll('[data-bp-parallax]').forEach(function (el) {
        var sp = parseFloat(el.getAttribute('data-bp-parallax')) || 0.15;
        var host = el.parentElement;
        var r = host.getBoundingClientRect();
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * -sp;
        el.style.transform = 'translateY(' + off + 'px)';
      });
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------- quick view ---------- */
  var qv, qvState = { product: null, imageIndex: 0, variantId: null };

  /* The shop's money_format stores the rupee sign as the HTML entity &#8377;, so
     Shopify.formatMoney hands back raw entity text. Everything here writes with
     textContent (never innerHTML), which would print "&#8377;150" literally — decode first. */
  function bpDecode(s) {
    if (!s || s.indexOf('&') === -1) return s;
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) return bpDecode(Shopify.formatMoney(cents));
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  /* BP perf: product.js image URLs are the ORIGINAL uploads — megabytes for a modal.
     The CDN resizes via a width param; URLs usually carry ?v= already, hence the
     query-aware join. */
  function bpSized(src, w) {
    src = String(src);
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* Colourway name → the two hexes a swatch is drawn from. Mirrors snippets/bp-colour-hex,
     and reads the SAME vocabulary: the list is printed onto the quick-view element by
     snippets/bp-colour-map, so adding a colour stays a one-file change rather than needing
     the Liquid and the JS kept in sync by hand. */
  var bpColourPairs = null;
  function bpColours(name) {
    if (bpColourPairs === null) {
      var host = document.querySelector('[data-bp-colour-map]');
      bpColourPairs = (host ? host.getAttribute('data-bp-colour-map') : '').split(',');
    }
    var words = String(name || '').toLowerCase().replace(/[-/&]/g, ' ').split(/\s+/);
    var found = [];
    words.forEach(function (w) {
      for (var i = 0; i < bpColourPairs.length; i++) {
        var kv = bpColourPairs[i].split(':');
        if (kv[0] === w) { found.push(kv[1]); return; }
      }
    });
    if (!found.length) return { c1: '#D6D2CD', c2: '#D6D2CD', known: false };
    /* first and LAST match, so "Black Gold Edition" reads black-to-gold */
    return { c1: found[0], c2: found[found.length - 1], known: true };
  }

  function openQuickView(handle, trigger) {
    qv = qv || document.querySelector('[data-bp-qv]');
    if (!qv) { window.location.href = '/products/' + handle; return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        qvState.product = p;
        qvState.imageIndex = 0;
        qvState.variantId = p.variants[0] && p.variants[0].id;

        qv.querySelector('[data-bp-qv-vendor]').textContent = (p.vendor || '').toUpperCase();
        qv.querySelector('[data-bp-qv-title]').textContent = p.title;
        qv.querySelector('[data-bp-qv-price]').textContent = money(p.price);
        var cmp = qv.querySelector('[data-bp-qv-compare]');
        var off = qv.querySelector('[data-bp-qv-off]');
        if (p.compare_at_price && p.compare_at_price > p.price) {
          cmp.textContent = money(p.compare_at_price);
          cmp.hidden = false;
          off.textContent = '-' + Math.round((1 - p.price / p.compare_at_price) * 100) + '%';
          off.hidden = false;
        } else { cmp.hidden = true; off.hidden = true; }

        /* Judge.me rating — clone the preview badge from the triggering card */
        var rating = qv.querySelector('[data-bp-qv-rating]');
        rating.innerHTML = '';
        var badge = trigger && trigger.closest('.bp-card') && trigger.closest('.bp-card').querySelector('.jdgm-preview-badge');
        badge = badge || document.querySelector('.bp-card[data-product-id="' + p.id + '"] .jdgm-preview-badge');
        if (badge) rating.appendChild(badge.cloneNode(true));

        /* gallery */
        var img = qv.querySelector('[data-bp-qv-image]');
        var thumbs = qv.querySelector('[data-bp-qv-thumbs]');
        thumbs.innerHTML = '';
        var images = p.images && p.images.length ? p.images : [];
        function setImage(i) {
          qvState.imageIndex = i;
          if (images[i]) { img.src = bpSized(images[i], 800); img.alt = p.title; }
          thumbs.querySelectorAll('button').forEach(function (b, bi) { b.classList.toggle('bp-active', bi === i); });
        }
        images.slice(0, 4).forEach(function (src, i) {
          var b = document.createElement('button');
          b.type = 'button';
          var t = document.createElement('img');
          t.src = bpSized(src, 160); t.alt = '';
          t.loading = 'lazy';
          b.appendChild(t);
          b.addEventListener('click', function () { setImage(i); });
          thumbs.appendChild(b);
        });
        if (images.length) setImage(0); else { img.removeAttribute('src'); }

        /* variants */
        var vwrap = qv.querySelector('[data-bp-qv-variants]');
        vwrap.innerHTML = '';
        if (p.variants.length > 1) {
          p.variants.forEach(function (v) {
            var hex = bpColours(v.title);
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'bp-chip bp-sw' + (hex.known ? '' : ' bp-sw--unknown') +
                          (v.available ? '' : ' bp-sw--oos') +
                          (v.id === qvState.variantId ? ' bp-chip--active' : '');
            b.title = v.title + (v.available ? '' : ' — sold out');
            b.setAttribute('aria-label', b.title);
            b.style.setProperty('--sw1', hex.c1);
            b.style.setProperty('--sw2', hex.c2);

            var disc = document.createElement('span');
            disc.className = 'bp-sw__disc';
            b.appendChild(disc);
            if (!v.available) {
              var slash = document.createElement('span');
              slash.className = 'bp-sw__slash';
              b.appendChild(slash);
            }
            /* a name with no colour in it keeps its text, so it is never an anonymous disc */
            if (!hex.known) {
              var txt = document.createElement('span');
              txt.className = 'bp-sw__text';
              txt.textContent = v.title;
              b.appendChild(txt);
            }

            b.disabled = !v.available;
            b.addEventListener('click', function () {
              qvState.variantId = v.id;
              qv.querySelector('[data-bp-qv-price]').textContent = money(v.price);
              vwrap.querySelectorAll('.bp-chip').forEach(function (c) { c.classList.remove('bp-chip--active'); });
              b.classList.add('bp-chip--active');
            });
            vwrap.appendChild(b);
          });
        }

        var add = qv.querySelector('[data-bp-qv-add]');
        add.disabled = !p.available;
        add.textContent = p.available ? 'Add to cart · ' + money(p.price) : 'Sold out';
        qv.querySelector('[data-bp-qv-link]').href = p.url || ('/products/' + handle);

        qv.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      })
      .catch(function () { window.location.href = '/products/' + handle; });
  }

  function closeQuickView() {
    if (!qv) return;
    qv.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function showToast(text) {
    var toast = document.querySelector('[data-bp-toast]');
    if (!toast) return;
    toast.textContent = text || 'Added to cart ✓';
    toast.hidden = false;
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.hidden = true; }, 2200);
  }

  /* ---------- post-add feedback: header cart count + button "Added ✓" pop ---------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        /* Showcase header: <a class="cart cart-icon--basketN"><svg/><div>N</div><span class="text-link">Cart (N)</span></a> */
        document.querySelectorAll('a.cart[class*="cart-icon"]').forEach(function (a) {
          var d = a.querySelector(':scope > div');
          if (d) {
            d.textContent = n;
            /* The badge is hidden by a .bp-cart-empty class while the cart is empty, and
               writing the new count does not clear it — so the first add wrote "1" into a
               still-hidden element and the icon looked unchanged. The global tidier runs on
               a 350ms timer that usually beats this fetch, so it cannot be relied on to
               clear the class either. Settle it here, where the real number is known. */
            d.classList.toggle('bp-cart-empty', n === 0);
            d.classList.remove('bp-cart-pop');
            void d.offsetWidth; /* restart animation */
            d.classList.add('bp-cart-pop');
          }
          var t = a.querySelector('.text-link');
          if (t) t.textContent = 'Cart' + (n > 0 ? ' (' + n + ')' : '');
        });
        /* generic fallbacks for other themes/sections */
        document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (el) { el.textContent = n; });
      })
      .catch(function () {});
  }

  function popAdded(btn) {
    if (!btn) return;
    if (!btn.__bpOrigHtml) btn.__bpOrigHtml = btn.innerHTML;
    btn.classList.add('bp-btn--added');
    btn.innerHTML = 'Added ✓';
    clearTimeout(btn.__bpAddedT);
    btn.__bpAddedT = setTimeout(function () {
      btn.classList.remove('bp-btn--added');
      btn.innerHTML = btn.__bpOrigHtml;
      btn.__bpOrigHtml = null;
    }, 1800);
  }

  window.bpAddedFx = { pop: popAdded, refresh: refreshCartCount };
  document.addEventListener('bp:cart:added', refreshCartCount);

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bp-quick-view]');
    if (trigger) {
      /* The card's full-cover .bp-card__link counts as the quick-view trigger;
         any other real link inside the card (e.g. "View full details") navigates. */
      var link = e.target.closest('a');
      if (!link || link.classList.contains('bp-card__link')) {
        e.preventDefault();
        openQuickView(trigger.getAttribute('data-product-handle'), trigger);
        return;
      }
    }
    if (e.target.closest('[data-bp-qv-close]')) { closeQuickView(); return; }
    if (e.target.closest('[data-bp-qv-add]')) {
      var btn = e.target.closest('[data-bp-qv-add]');
      if (!qvState.variantId) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: qvState.variantId, quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          closeQuickView();
          showToast('Added to cart ✓');
          document.dispatchEvent(new CustomEvent('bp:cart:added'));
        })
        .catch(function () { showToast('Could not add — try the product page'); })
        .finally(function () { btn.disabled = false; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickView(); });

  /* ---------- racket finder (links to collection with filter params) ---------- */
  function initFinder() {
    document.querySelectorAll('[data-bp-finder]').forEach(function (finder) {
      var base = finder.getAttribute('data-collection-url') || '/collections/all';
      var cta = finder.parentElement.querySelector('[data-bp-finder-cta]');
      var picked = {};
      finder.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-bp-finder-chip]');
        if (!chip) return;
        var group = chip.getAttribute('data-group');
        var value = chip.getAttribute('data-value');
        if (picked[group] === value) { delete picked[group]; } else { picked[group] = value; }
        finder.querySelectorAll('[data-bp-finder-chip][data-group="' + group + '"]').forEach(function (c) {
          c.classList.toggle('bp-chip--active', c === chip && picked[group] === value);
        });
        var params = new URLSearchParams();
        Object.keys(picked).forEach(function (k) { params.set(k, picked[k]); });
        var qs = params.toString();
        if (cta) {
          cta.href = qs ? base + '?' + qs : base;
          cta.textContent = qs ? 'Show matching rackets →' : 'Show all rackets →';
        }
      });
    });
  }

  /* ---------- collection: client-side filters (spec metafields) + infinite scroll ---------- */
  function initCollection() {
    var bar = document.querySelector('[data-bp-filters]');
    var grid = document.querySelector('[data-bp-grid]');
    if (!bar || !grid || grid.__bpInit) return;
    grid.__bpInit = true;

    var panel = document.querySelector('[data-bp-filter-panel]');
    var emptyEl = document.querySelector('[data-bp-empty]');
    var countEl = document.querySelector('[data-bp-count]');
    var state = { brand: new Set(), tension: new Set(), balance: new Set(), level: new Set() };
    var loading = false;

    /* preset from URL params (finder deep-links) */
    var params = new URLSearchParams(window.location.search);
    ['brand', 'tension', 'balance', 'level'].forEach(function (k) {
      var v = params.get(k);
      if (v) v.split(',').forEach(function (x) { if (x) state[k].add(x.toLowerCase()); });
    });

    /* A one-of group must not arrive holding two values. The finder only ever writes one
       per group, but a hand-built or shared URL can carry `?balance=head+heavy,head+light`,
       and that would light two chips in a group whose whole point is that only one can be
       on. Which groups are one-of is declared in the markup (data-bp-single), not listed
       here, so adding a group later needs no change to this file. */
    document.querySelectorAll('[data-bp-filter-chip][data-bp-single]').forEach(function (c) {
      var k = c.getAttribute('data-filter');
      if (state[k] && state[k].size > 1) {
        var first = state[k].values().next().value;
        state[k].clear();
        state[k].add(first);
      }
    });

    /* The number on a racket is the MAXIMUM tension it is rated for, and the chip is the
       tension the customer wants to play at — so the test is "can this frame take it",
       not "is the rating inside this band". A 32 lb racket happily strings at 28, so it
       belongs in the 28 chip; a 28 lb racket cannot take 30, so it must stay out of the
       29–32 chip. Each chip therefore carries the minimum rating that satisfies it. */
    var TENSION_MIN = { 'u28': 28, '29-32': 29, '33-36': 33, '37p': 37 };

    function cardMatches(card) {
      if (state.brand.size) {
        var vendor = (card.getAttribute('data-vendor') || '').toLowerCase();
        if (!state.brand.has(vendor)) return false;
      }
      if (state.balance.size) {
        var bal = (card.getAttribute('data-balance') || '').toLowerCase();
        if (!state.balance.has(bal)) return false;
      }
      if (state.level.size) {
        /* a card can hold more than one level — the price bands overlap at ₹2,000–2,100,
           and a racket in that window belongs under both chips */
        var lvls = (card.getAttribute('data-level') || '').toLowerCase().split(/\s+/).filter(Boolean);
        if (!lvls.length) return false;
        var lvlOk = false;
        state.level.forEach(function (v) { if (lvls.indexOf(v) !== -1) lvlOk = true; });
        if (!lvlOk) return false;
      }
      if (state.tension.size) {
        /* take the HIGHEST number in the value, so "24-30 lbs" reads as a 30 lb ceiling
           rather than the 2430 a plain digit-strip would produce */
        var nums = (card.getAttribute('data-tension') || '').match(/\d+/g);
        if (!nums) return false;
        var t = Math.max.apply(null, nums.map(Number));
        var ok = false;
        state.tension.forEach(function (key) {
          var min = TENSION_MIN[key];
          if (min !== undefined && t >= min) ok = true;
        });
        if (!ok) return false;
      }
      return true;
    }

    function anyFilterActive() {
      return state.brand.size || state.tension.size || state.balance.size || state.level.size;
    }

    function applyFilters() {
      var cards = grid.querySelectorAll('.bp-card');
      var visible = 0;
      cards.forEach(function (card) {
        var show = cardMatches(card);
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (emptyEl) emptyEl.hidden = visible > 0;
      if (countEl && anyFilterActive()) countEl.textContent = visible + ' matching';
      var badge = document.querySelector('[data-bp-filter-count]');
      if (badge) {
        var n = state.tension.size + state.balance.size + state.level.size;
        badge.hidden = n === 0;
        badge.textContent = n;
      }
      /* keep pulling pages while filters hide most of the current batch */
      if (anyFilterActive() && visible < 12) loadMore();
      return visible;
    }

    function syncChips() {
      document.querySelectorAll('[data-bp-filter-chip]').forEach(function (chip) {
        var f = chip.getAttribute('data-filter');
        var v = (chip.getAttribute('data-value') || '').toLowerCase();
        chip.classList.toggle('bp-chip--active', state[f] && state[f].has(v));
      });
      var allChip = document.querySelector('[data-bp-brand-all]');
      if (allChip) allChip.classList.toggle('bp-chip--active', state.brand.size === 0);
    }

    function loadMore() {
      var sentinel = document.querySelector('[data-bp-infinite]');
      if (!sentinel || loading) return;
      var url = sentinel.getAttribute('data-next-url');
      if (!url) { sentinel.remove(); return; }
      loading = true;
      sentinel.classList.add('bp-infinite--busy');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-bp-grid]');
          if (newGrid) {
            newGrid.querySelectorAll('.bp-card').forEach(function (card) {
              card.classList.add('bp-in'); /* skip reveal animation for appended cards */
              grid.appendChild(card);
            });
          }
          var newSentinel = doc.querySelector('[data-bp-infinite]');
          if (newSentinel) {
            sentinel.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
          } else {
            sentinel.remove();
          }
          applyFilters();
        })
        .catch(function () { /* network hiccup: keep sentinel for retry on next scroll */ })
        .finally(function () {
          loading = false;
          var s = document.querySelector('[data-bp-infinite]');
          if (s) s.classList.remove('bp-infinite--busy');
        });
    }

    /* infinite scroll observer (sentinel is also click/keyboard-activatable as a fallback) */
    var sentinel = document.querySelector('[data-bp-infinite]');
    if (sentinel) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) loadMore(); });
        }, { rootMargin: '600px 0px' });
        io.observe(sentinel);
      } else {
        sentinel.classList.add('bp-infinite--manual');
      }
      sentinel.addEventListener('click', loadMore);
      sentinel.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') loadMore(); });
    }

    /* chip clicks (brand bar + panel) */
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-bp-filter-chip]');
      if (chip) {
        var f = chip.getAttribute('data-filter');
        var v = (chip.getAttribute('data-value') || '').toLowerCase();

        /* Two kinds of group, and the difference is real rather than cosmetic.

           Tension stays multi-select because the chips are open-ended bands: "I play at 28
           OR at 33" is a sensible thing to want, and the match is "can this frame take it",
           so several bands together widen the result set.

           Balance and player level are one-of: a racket is head heavy or head light, and
           ticking both asks for every racket at once — the same result as no filter, while
           looking like a filter is applied. Those chips carry data-bp-single, so picking
           one replaces whatever was there instead of adding to it. Tapping the active one
           still clears the group: clearing the set first and then honouring `had` gives
           that for free.

           The rule lives on the chip, not in a list of group names here, so the markup
           stays the single place that says which groups behave which way. */
        var had = state[f].has(v);
        if (chip.hasAttribute('data-bp-single')) state[f].clear();
        if (had) state[f].delete(v); else state[f].add(v);

        syncChips();
        applyFilters();
        return;
      }
      if (e.target.closest('[data-bp-brand-all]')) {
        state.brand.clear();
        syncChips();
        applyFilters();
        return;
      }
      if (e.target.closest('[data-bp-panel-toggle]')) {
        var t = e.target.closest('[data-bp-panel-toggle]');
        if (panel) {
          panel.hidden = !panel.hidden;
          t.setAttribute('aria-expanded', String(!panel.hidden));
        }
        return;
      }
      if (e.target.closest('[data-bp-filter-clear]')) {
        Object.keys(state).forEach(function (k) { state[k].clear(); });
        syncChips();
        applyFilters();
      }
    });

    syncChips();
    if (anyFilterActive()) {
      if (panel && (state.tension.size || state.balance.size || state.level.size)) panel.hidden = false;
      applyFilters();
    }
  }

  /* ---------- collection sort ----------
     Drives our own button + list (bp-collection-grid.liquid). It replaced a native <select>
     that the base theme's JS was swapping out from under our styling after load. */
  function initSort() {
    document.querySelectorAll('[data-bp-sort-wrap]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-bp-sort-toggle]');
      var menu = wrap.querySelector('[data-bp-sort-menu]');
      if (!btn || !menu) return;

      function open(state) {
        menu.hidden = !state;
        btn.setAttribute('aria-expanded', String(state));
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();          /* the document listener below would close it again */
        open(menu.hidden);
      });

      menu.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-bp-sort-value]');
        if (!opt) return;
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', opt.getAttribute('data-bp-sort-value'));
        window.location.href = url.toString();
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) open(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !menu.hidden) { open(false); btn.focus(); }
      });
    });
  }

  /* ---------- Judge.me review pagination ----------
     Which page you are on has to be visible, and the widget's own "current" class name is
     not dependable — it varies by widget version, so styling it was a coin flip that came
     up wrong. Mark it here instead.

     Order of confidence: a vendor class that looks current → the page number we recorded
     when you clicked → the first page on a fresh load. The widget replaces this markup
     wholesale on every page change, so an observer re-marks it each time. */
  function initReviewPager() {
    var section = document.querySelector('.bp-pdp-reviews');
    if (!section) return;

    function mark() {
      section.querySelectorAll('.jdgm-paginate').forEach(function (pager) {
        var pages = pager.querySelectorAll('[class*="jdgm-paginate__page"]');
        if (!pages.length) return;
        var current = null;

        pages.forEach(function (p) {
          if (/active|curr/i.test(p.className)) current = p;
        });
        if (!current) {
          var want = section.__bpPage || pages[0].textContent.trim();
          pages.forEach(function (p) { if (p.textContent.trim() === want) current = p; });
        }
        pages.forEach(function (p) { p.classList.toggle('bp-pg-on', p === current); });
      });
    }

    section.addEventListener('click', function (e) {
      var page = e.target.closest('[class*="jdgm-paginate__page"]');
      if (page) section.__bpPage = page.textContent.trim();
      /* the widget swaps the list out after its fetch; the observer catches that, this is
         just so the tap feels immediate */
      setTimeout(mark, 60);
    });

    mark();
    if ('MutationObserver' in window) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(mark, 80);
      }).observe(section, { childList: true, subtree: true });
    }
  }

  function init() {
    initReveals();
    initParallax();
    initFinder();
    initSort();
    initReviewPager();
    initCollection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run reveals when Shopify theme editor injects/reorders sections */
  document.addEventListener('shopify:section:load', initReveals);
})();
